import React from "react";
import { AuthProvider } from "./authProvider";
import { LanguageRegionProvider } from "./LanguageRegionContext";
import { ProgressProvider } from "./ProgressContext";

const CombinedProvider = ({ children }) => {
  return (
    <ProgressProvider>
      <LanguageRegionProvider>
        <AuthProvider>{children}</AuthProvider>
      </LanguageRegionProvider>
    </ProgressProvider>
  );
};

export default CombinedProvider;
